<div class="container-fluid">

  <header class="row">
    <div class="col-12 col-md-12 col-lg-4 col-xl-2 col-xxl-1">
      <img src="../../../../assets/images/logo-blue@3x.png" style="width: 125px;">
    </div>
    <div class="col-12 col-md-12 col-lg-8 col-xl-10 col-xxl-11 step-container">
      <ul class="step step-md step-inline">
        <li class="step-item">
          <div class="step-content-wrapper">
            <span class="step-icon step-icon-soft-primary">1</span>
            <div class="step-content">
              <h4 class="step-title">Créez votre compte</h4>
            </div>
          </div>
        </li>
        <li class="step-item active">
          <div class="step-content-wrapper">
            <span class="step-icon step-icon-primary">2</span>
            <div class="step-content">
              <h4 class="step-title">Créez votre entreprise</h4>
            </div>
          </div>
        </li>

        <li class="step-item">
          <div class="step-content-wrapper">
            <span class="step-icon step-icon-soft-primary">3</span>
            <div class="step-content">
              <h4 class="step-title">Choisissez votre abonnement</h4>
            </div>
          </div>
        </li>
        <li class="step-item">
          <div class="step-content-wrapper">
            <span class="step-icon step-icon-soft-primary">4</span>
            <div class="step-content">
              <h4 class="step-title">Bienvenue dans Optitax!</h4>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </header>

  <div class="row d-flex align-items-center">
    <div class="col-12 col-lg-6">
      <div class="form-container">
        <form (ngSubmit)="form.submit()" [formGroup]="form">

          <h1>Quel est le nom de votre entreprise?</h1>

          <app-alert-messages [maximumNumberOfMessages]="1"></app-alert-messages>

          <div class="row mb-3">
            <div class="col-12">
              <!-- First name -->
              <magieno-input-text-field [advancedFormControl]="organizationName"></magieno-input-text-field>
            </div>
          </div> <!-- / .row -->

          <!-- Button -->
          <magieno-button [button]="form.getButton('SAVE')" class="mb-5"></magieno-button>

          <p class="mt-5">
            @if (this.authService.user$ | async; as user) {
              <span>
                Vous êtes connectés avec:<strong>{{ user.email }}</strong>
              </span>
            }
            (<a href="logout">Se déconnecter</a>)</p>
          </form>
        </div>
      </div>
      <div class="col-lg-6 col-xl-5 col-xxl-4 d-none d-sm-none d-md-none d-lg-block illustration">
        <img class="img-fluid"
          src="../../../../assets/images/7375204_businessman_card_business_company_commerce_icon.svg">
        </div>
      </div>

    </div>